<soft-ds-card class="w-full">
  <soft-ds-card-header>
    <soft-ds-card-leading variant="tinted" tone="info">
      <soft-ds-icon name="fa-regular fa-file-invoice-dollar" />
    </soft-ds-card-leading>
    <soft-ds-card-title>{{ title() | translate }}</soft-ds-card-title>
    <soft-ds-card-description>{{ subtitle() | translate }}</soft-ds-card-description>
  </soft-ds-card-header>

  <soft-ds-card-body class="flex flex-col">
    @if (error(); as error) {
      <soft-ds-empty-state
        variant="error"
        size="sm"
        [icon]="error.icon ?? null"
        [title]="error.subject ? (error.subject | translate) : null"
        [description]="(error.message | translate | interpolate: error.data) ?? null"
        data-testid="offene-posten-error"
      />
    } @else if (loading()) {
      <div class="flex flex-col gap-3 min-h-[25vh]" data-testid="offene-posten-loading">
        <soft-ds-loading-skeleton width="8rem" height="1.75rem" />
        <div class="flex flex-1 flex-col justify-center gap-4">
          @for (bar of [70, 45, 85, 30]; track $index) {
            <div class="flex items-center gap-3">
              <soft-ds-loading-skeleton width="6rem" height="0.75rem" />
              <div class="flex-1">
                <soft-ds-loading-skeleton
                  [width]="bar + '%'"
                  height="1.25rem"
                  radius="0 var(--ds-radius-md) var(--ds-radius-md) 0"
                />
              </div>
            </div>
          }
        </div>
      </div>
    } @else if (offenePosten().length === 0) {
      <soft-ds-empty-state
        size="sm"
        icon="fa-regular fa-file-invoice-dollar"
        [title]="'#OFFENE_POSTEN.EMPTY' | translate"
        data-testid="offene-posten-empty"
      />
    } @else if (chartData(); as chartData) {
      @if (faelligkeitenInTotal(); as faelligkeitenInTotal) {
        <button
          type="button"
          class="self-start text-2xl font-bold cursor-pointer"
          [ngStyle]="{ color: this.color() }"
          (click)="showOffenePostenDialog()"
          data-testid="offene-posten-total"
        >
          {{
            faelligkeitenInTotal
              | currencyFormat: 'EUR' : 'symbol' : 'after' : '1.2-2' : 'de-AT'
          }}
        </button>
      }
      <div class="w-full mt-2 max-h-[25vh] min-h-[25vh]" #container2Ref>
        <ngx-charts-bar-horizontal
          #chart
          class="bg-surface block mt-1"
          [view]="
            $any(
              (chartData?.length || 1) < 4
                ? undefined
                : [container2Ref.offsetWidth, (chartData?.length || 1) * 20 + 100]
            )
          "
          [scheme]="$any(chartColorScheme())"
          [legend]="false"
          [gradient]="false"
          [xAxis]="true"
          [yAxis]="true"
          [results]="chartData"
          [roundDomains]="true"
          [roundEdges]="false"
          [tooltipDisabled]="false"
          [noBarWhenZero]="true"
          [showDataLabel]="false"
          (select)="onSelect($event)"
          [xAxisTickFormatting]="formatDataLabel"
          [dataLabelFormatting]="formatDataLabel"
        >
        </ngx-charts-bar-horizontal>
      </div>
    }
  </soft-ds-card-body>
</soft-ds-card>
